import Transform from './Base';

export default class OutfitsTransform extends Transform {
  /**
   * Method used to transform fetched outfits.
   *
   * @param outfit The fetched team.
   *
   * @returns {Object} The transformed outfit.
   */
  static fetch(outfit) {
    return {
      id: outfit._id,
      team_id: outfit.team_id,
      jersey: outfit.jersey,
      shorts: outfit.shorts,
      icon: outfit.shorts ? `svg-kit-${outfit.jersey}-${outfit.shorts}--24` : `svg-kit-${outfit.jersey}--24`,
    };
  }
}
